import axios from "axios";
import AlertStore from '@/stores/AlertStore'
import hasPermission from "../filters/hasPermission";
import {
  ENDPOINT_BROUILLON,
  ENDPOINT_EXPORT,
  ENDPOINT_GPEC_SYNTHESE_REALISE, ENDPOINT_GPEC_SYNTHESE_REALISE_REJECT,
  ENDPOINT_GPEC_SYNTHESE_REALISE_VALIDATE,
  ENDPOINT_INIT,
  ENDPOINT_SEARCH
} from "../constants/endpoints";
import {libelles} from "../constants/libelles";

let store = {
  debug: true,

  init(marcheId, trimestreId) {
    return axios
        .get(ENDPOINT_GPEC_SYNTHESE_REALISE + ENDPOINT_INIT, {params: {marcheId, trimestreId}})
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  getCurrentDraft(marcheId, trimestreId) {
    return axios
        .get(ENDPOINT_GPEC_SYNTHESE_REALISE + ENDPOINT_BROUILLON, {params: {marcheId, trimestreId}})
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  get(id) {
    return axios
        .get(ENDPOINT_GPEC_SYNTHESE_REALISE + '/' + id)
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  create(gpecSyntheseRealise) {
    return axios
        .post(ENDPOINT_GPEC_SYNTHESE_REALISE, gpecSyntheseRealise)
        .then((response) => {
          let message = response.data.dispense ? libelles.messageCreateFormulaireWithDispense : 'Bilan trimestriel des recrutements créé avec succès.'
          AlertStore.pushSuccess(message);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  saveDraft(synthese) {
    return axios
        .put(ENDPOINT_GPEC_SYNTHESE_REALISE + ENDPOINT_BROUILLON, synthese)
        .then((value) => {
          AlertStore.pushSuccess('Bilan trimestriel des recrutements enregistré avec succès');
          return value.data;
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  update(synthese) {
    return axios
        .put(ENDPOINT_GPEC_SYNTHESE_REALISE, synthese)
        .then(() => {
          const isAdmin = hasPermission(['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR']);
          const correspondantMsg = "Modification de bilan trimestriel des recrutements soumise pour approbation.";
          const adminMsg = "Bilan trimestriel des recrutements modifié avec succès.";
          const successMessage = isAdmin || !synthese.jourSoumissionPassed ? adminMsg : correspondantMsg;
          AlertStore.pushSuccess(successMessage);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  delete(gpecSyntheseRealise) {
    return axios
        .delete(ENDPOINT_GPEC_SYNTHESE_REALISE + '/' + gpecSyntheseRealise.id)
        .then(() => {
          const isAdmin = hasPermission(['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR']);
          const correspondantGpecMsg = "Suppression de bilan trimestriel des recrutements soumise pour approbation.";
          const adminMsg = "Bilan trimestriel des recrutements supprimé avec succès.";
          const successMessage = isAdmin || gpecSyntheseRealise.statut === 'ATTENTE_MODIFICATION' || !gpecSyntheseRealise.jourSoumissionPassed ? adminMsg : correspondantGpecMsg;
          AlertStore.pushSuccess(successMessage);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  search(synthese, pageIndex, pageSize, sortOptions) {
    const recherche = this.syntheseToRecherche(synthese);
    let url = `${ENDPOINT_GPEC_SYNTHESE_REALISE + ENDPOINT_SEARCH}?page=${pageIndex}&size=${pageSize}`;
    if (sortOptions) {
      for (const sortOption of sortOptions) {
        url += `&sort=${sortOption.sortBy},${sortOption.sortDirection}`;
      }
    }
    return axios
        .post(url, recherche);
  },

  export(synthese) {
    const recherche = this.syntheseToRecherche(synthese);
    let url = `${ENDPOINT_GPEC_SYNTHESE_REALISE + ENDPOINT_EXPORT}`;
    return axios
        .post(url, recherche);
  },

  exportById(syntheseId) {
    return axios.get(ENDPOINT_GPEC_SYNTHESE_REALISE + '/' + syntheseId + ENDPOINT_EXPORT);
  },

  validate(synthese) {
    return axios
        .post(ENDPOINT_GPEC_SYNTHESE_REALISE_VALIDATE + '/' + synthese.id)
        .then(() => {
          const operation = synthese.statut === 'ATTENTE_MODIFICATION' ? 'modification' : 'suppression';
          AlertStore.pushSuccess(`Demande de ${operation} de bilan trimestriel des recrutements approuvée avec succès.`);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  reject(id, commentaire) {
    return axios.post(`${ENDPOINT_GPEC_SYNTHESE_REALISE_REJECT}/${id}`, {
      message: commentaire
    })
      .then((response) => {
        if (response.status === 204) {
          AlertStore.pushSuccess('La demande de bilan trimestriel des recrutements a été rejetée avec succès.')
        }
      }).catch((error) => {
        console.log(error)
        AlertStore.pushError('La demande de bilan trimestriel des recrutements n\'a pas pu être rejetée.')
      })
  },

  syntheseToRecherche(synthese) {
    let recherche = [];
    recherche.push({key: 'marche', operation: '=', value: synthese.marche});
    recherche.push({key: 'ligne', operation: '=', value: synthese.ligne});
    recherche.push({key: 'statut', operation: '€', value: synthese.statut});
    recherche.push({key: 'trimestre', operation: '=', value: synthese.trimestre});
    recherche.push({key: 'territoire', operation: '=', value: synthese.territoire});
    return recherche;
  }

};

export default store;
